interface StorylineTitleProps {
  /** The analyst-written headline; absent or null when none was kept. */
  title?: string | null;
  /** Shown when the storyline has no title (the study name). */
  fallback?: string | null;
}

/**
 * The storyline's headline in the report's display face, above the thesis:
 * the analyst's title, else the study name. Clamped to two lines.
 */
export function StorylineTitle(props: StorylineTitleProps) {
  const { title, fallback } = props;

  const text = title?.trim() || fallback?.trim();

  if (!text) {
    return null;
  }

  return (
    <h2
      className="mb-4 line-clamp-2 pb-[0.1em] font-display text-2xl leading-[1.2] tracking-tight text-[hsl(var(--report-heading))] md:text-3xl"
      title={text}
      data-testid="storyline-title"
    >
      {text}
    </h2>
  );
}
